import { render, staticRenderFns } from "./AnaliseMargemRede.vue?vue&type=template&id=ab4d77e2&scoped=true&"
import script from "./AnaliseMargemRede.vue?vue&type=script&lang=js&"
export * from "./AnaliseMargemRede.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseMargemRede.vue?vue&type=style&index=0&id=ab4d77e2&scoped=true&lang=css&"
import style1 from "./AnaliseMargemRede.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4d77e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
